import { Component } from 'react';
import { MDBInput } from 'mdbreact';
import { Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { MapStreamBuilder, withContext } from './../../provider';
import { FormBloc, FormInputField, ValueHandler } from '../../../src/controller/form_bloc';
import { Navigation } from '../../controller';

export class LoginForm extends Component<{
	formBloc: FormBloc<{ email: string; password: string }>;
	navigation: Navigation.Bloc;
}> {
	render() {
		return (
			<>
				<Form
					onKeyDown={e => {
						if (e.key === 'Enter' && e.target instanceof HTMLInputElement) {
							e.preventDefault();
							this.props.formBloc.onSubmit();
						}
					}}
				>
					<Form.Group className="m-2" controlId="formBasicEmail">
						<FormInputField
							controller={this.props.formBloc}
							objectKey="email"
							builder={(
								value: string | undefined,
								onChange: ValueHandler<string>,
								validationError: string | undefined
							) => {
								return (
									<>
										<MDBInput
											label="EMAIL ID"
											type="email"
											outline
											getValue={e => onChange(e as string)}
											value={value}
										/>
										<Form.Text style={{ color: '#DC2E20' }} className="pb-3">
											{validationError}
										</Form.Text>
									</>
								);
							}}
						/>
					</Form.Group>

					<Form.Group className="m-2 mb-3" controlId="formBasicPassword">
						<FormInputField
							controller={this.props.formBloc}
							objectKey="password"
							builder={(
								value: string | undefined,
								onChange: ValueHandler<string>,
								validationError: string | undefined
							) => {
								return (
									<>
										<MDBInput
											label="PASSWORD"
											type="password"
											outline
											getValue={e => onChange(e as string)}
											value={value}
										/>
										<Form.Text className="pb-3" style={{ color: '#DC2E20' }}>
											{validationError}
										</Form.Text>
									</>
								);
							}}
						/>
					</Form.Group>
					<div className="d-grid gap-2">
						<MapStreamBuilder
							stream={this.props.formBloc.submitEnabled}
							map={(e: boolean) => (e ? '' : 'disabled')}
							builder={(cls: string) => {
								return (
									<>
										<button
											type="submit"
											className={`btn button ${cls}`}
											style={{
												backgroundColor: '#DB2A1D',
												color: 'white',
											}}
											onClick={e => {
												e.preventDefault();
												this.props.formBloc.onSubmit();
											}}
										>
											Login
										</button>
									</>
								);
							}}
						/>
						<>
							<a
								style={{
									color: '#DB2A1D',
									placeSelf: 'center',
								}}
								href="https://membership.nammabnp.org/join/corporator-registration"
								target="_blank"
							>
								Sign Up
							</a>
							<a
								style={{
									color: '#DB2A1D',
									placeSelf: 'center',
								}}
								onClick={this.props.navigation.onForgotPasswordClicked}
							>
								Forgot Password
							</a>
						</>
					</div>
				</Form>
			</>
		);
	}
}
// TODO remove with context and pass as props
export default withContext(LoginForm);
